<template>
  <div class="header">
    <div class="headerBox">
      <p>知识库管理系统</p>
    </div>
    <!-- header内容填充。设置布局 -->
    <div class="header-top">
      <!-- 菜单伸缩按钮 -->
      <img class="menuIcon" :src="isCollapse ? require('@/assets/base/shrink.png') : require('@/assets/base/shrink.png')"
        :style="{ transform: !isCollapse ? 'scaleX(1)' : 'scaleX(-1)' }" alt="菜单图标" @click="CHANGE_COLLAPSE" />
      <!-- 时间/logo标题 -->
      <div class="btn-menu">
        <div class="backContainer" @click="centerDialogVisible = true">
          <img src="@/assets/base/back.png" alt="回退" class="backBtn" />
        </div>

        <!-- <el-button type="info" size="mini" @click="jump(centerDialogVisible = false)">回退</el-button> -->
        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="440px" center :append-to-body="true"
          :modal-append-to-body="false" :close-on-click-modal="false" :close-on-press-escape="false"
          custom-class="custom-dialog" style="margin-top:10%;" class="headerDialog">
          <span align="center" style="display: block; font-size: 17px;color: #ffffff;">此操作将退回到知识库领域管理页面！</span>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button type="text" @click="quit(centerDialogVisible = false)"
              style="width: 30%; background-color: #71b9f4; color: rgb(255, 255, 255); padding: 7px;">退出登录</el-button> -->
            <el-button @click="jump(centerDialogVisible = false)" type="primary" class="mainButton">确定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <!-- 退出按钮 -->
    <div class="header-right">
      <el-button class="cancelButton" @click="quit">退出</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      centerDialogVisible: false,
      systemDiscript: false,
    };
  },
  mounted() {
    // window.addEventListener('popstate', this.handlePopState);
  },
  computed: {
    ...mapGetters(["isCollapse"]),
  },
  // beforeDestroy() {
  //   window.removeEventListener('popstate', this.handlePopState);
  // },
  methods: {
    // handlePopState() {
    //   this.centerDialogVisible= true;
    // },
    // goBack() {
    //   window.history.back();
    // },
    ...mapActions(["CHANGE_COLLAPSE"]),
    /* quit() {
      window.sessionStorage.removeItem("token");
      this.$router.push({
        path: "/login", // 修正路径为绝对路径
      });
      this.centerDialogVisible = false; // 关闭对话框
      this.$message({
        type: "success",
        message: "成功退出登录!",
      });
    }, */
    quit() {
      this.$router.push({
        path: "/login", // 修正路径为绝对路径
      });
      this.$message({
        type: "success",
        message: "成功退出登录!",
      });
    },
    jump() {
      this.$router.push({
        path: "/project",
      });
      this.centerDialogVisible = false; // 关闭对话框
      this.$message({
        type: "success",
        message: "知识库管理跳转成功!",
      });
    },

  },
};
</script>

<style lang="less" scoped>
.systemDialog {
  background: url("@/assets/base/系统说明.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 34px;
}

.systemDialog.hover,
.systemDialog:hover {
  cursor: pointer;
}

.backContainer {
  display: flex;
  /* 使用 flex 布局 */
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中（可选，根据需要） */
  height: 100%;
  /* 确保容器有高度 */
}

.backBtn {
  cursor: pointer;
  // padding-top: 1px;
  margin-right: 24px;
  width: 80px;
  height: 36px;
}

.menuIcon {
  cursor: pointer;
  // font-size: 25px;
  // color: white;
  width: 46px;
  height: 36px;
  margin-left: 24px;
}

span {
  font-size: 1.5vw;
}

// .button{
//   margin-left: 20px;
//   padding: 0 !important;

// }
.btn-menu {
  // margin-right: 6%;
  // margin-top: 24px;
  // float: right;
}

.header-top {
  margin: 8px 0;
  width: 100%;
  // background-color: #ffffff;
  // padding: 0 18px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* 两端对齐 */
}
.header-right{
  position: absolute;
  right: 27px;
  top: 20px;
}
.header {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 122px;
  // background-image: url("@/assets/base/header.png");
}

.headerBox {
  padding-right: 20px;
  margin: 0;
  color: #fff;
  /* 调整字体颜色，与背景形成对比 */
  font-size: 24px;
  /* 调整文字大小 */
  display: flex;
  /* 使用 Flexbox 居中内容 */
  align-items: center;
  /* 垂直居中 */
  justify-content: space-between;
  /* 水平居中 */
  width: 100%;
  /* 占满整个宽度 */
  height: 70px;
  /* 固定高度 */
  background-image: url("@/assets/base/header.png");
  background-repeat: no-repeat;
  /* 防止图片重复 */
  background-position: center;
  /* 图片居中 */
  background-size: cover;
  /* 图片按容器宽高比例裁剪适应 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  /* 添加阴影效果 */

}
.headerBox p {
  margin-left: 54px;      
  text-align: center;    /* 文本水平居中 */
  flex: 1;               /* 占据剩余空间，使其真正居中 */
}

.systemStyle .dialog-text {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  margin-bottom: 16px;
}

.btnBox {
  background-color: #fff;
  width: 100%;
  height: 36px;
  // background-color: #fff;
}

.headerDialog /deep/ .el-dialog__body {
  width: 440px;
  height: 100px;
}

/* 自定义对话框样式 */
.custom-dialog {
  .el-dialog__wrapper {
    z-index: 10000;
    /* 确保弹窗在最上层 */
    top: 50%;
    /* 上边距为页面高度的一半 */
    left: 50%;
    /* 左边距为页面宽度的一半 */
    transform: translate(-50%, -50%);
    /* 使用transform属性将弹窗向左上角偏移自身宽高的一半，实现居中对齐 */

  }
}

.el-submenu__icon-arrow {
  color: #fff;
}
</style>
